export default __webpack_public_path__ + "static/media/launching.257e1084.png";